module.exports = __webpack_public_path__ + "static/img/s82.4a3e744f.png";